// Generated by CoffeeScript 1.7.1
import io from 'socket.io-client'

class AppWire {
  constructor(options) {
    var defaultOptions
    if (options == null) {
      options = {}
    }
    defaultOptions = {
      server: window.location.host || 'localhost',
      port: '',
      app: void 0,
      socket: void 0
    }
    this.activeCodes = []
    this.options = { ...defaultOptions, ...options }
    this.connect()
  }

  connect() {
    if (!this.options.socket) {
      this.options.socket = io(this.options.server, {
        secure: true,
        // transports: ['websocket'],
        autoConnect: false
        // upgrade: false
      })
      this.options.socket.on(
        'disconnect',
        () => {
          console.log('disconnected... reconnecting')
          // this.options.socket = false
          // this.connect()
        })
      this.options.socket.on(
        'connect',
        () => {
          console.log('connected !')
          var code, _i, _len
          this.options.socket.emit('linkApp', {
            appid: this.options.appid
          })
          for (_i = 0, _len = this.activeCodes.length; _i < _len; _i++) {
            code = this.activeCodes[_i]
            this.subscribe(code)
          }
        }
      )
      this.options.socket.connect()
    }
  }

  subscribe(code) {
    if (this.options.socket.connected) {
      return this.options.socket.emit('add', {
        follow: code
      })
    }
  }

  unsubscribe(code) {
    if (this.options.socket.connected) {
      return this.options.socket.emit('remove', {
        follow: code
      })
    }
  }

  onConnect(fn, executeIfConnected = true) {
    this.options.socket.on('connect', fn)
    if (executeIfConnected && this.options.socket.connected) {
      fn()
    }
  }

  on(code, fn) {
    this.activeCodes.push(code)
    this.subscribe(code)
    return this.options.socket.on(code, fn)
  }

  off(code) {
    this.activeCodes.splice(this.activeCodes.indexOf(code), 1)
    this.unsubscribe(code)
    return this.options.socket.off(code)
  }
}

export default AppWire

/*
  //@ sourceMappingURL=appwire.map
  */



// WEBPACK FOOTER //
// ./src/utils/appwire.js